'use client'

import {
   AnimateOnScroll,
   Box,
   Faq,
   Hero,
   Services,
   TrustedProducts
} from '@blocks'
import {sitePageCanvasBackgroundHex} from '@constants'

export const HomePageContent = () => {
   return (
      <Box bg={sitePageCanvasBackgroundHex}>
         <Hero />
         <AnimateOnScroll>
            <Services />
         </AnimateOnScroll>
         <AnimateOnScroll>
            <TrustedProducts tone={'blue'} />
         </AnimateOnScroll>
         <AnimateOnScroll>
            <Faq categoryPriority={'general-questions'} />
         </AnimateOnScroll>
      </Box>
   )
}
